import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {
  isActivePaymentsLoading,
  getNewClubBookingCount,
  getNewDinnerBookingCount,
  getNewPaymentCount
} from "state/school_money/selectors";

import Preloader from "components/app/home/Preloader";
import Card from "components/app/home/Card";
import BulletItem from "components/app/home/BulletItem";

class NewPayments extends React.Component {
  
  getPaymentTypePath(paymentType) {
    switch (paymentType) {
      case "payment": return "payments";
      case "dinnerBooking": return "dinners";
      case "clubBooking": return "clubs";
      default: return "";
    }
  }
  
  getPaymentTypeLabel(paymentType) {
    switch (paymentType) {
      case "payment": return "Payments";
      case "dinnerBooking": return "Dinner Bookings";
      case "clubBooking": return "Club Bookings";
      default: return "";
    }
  }
  
  renderItem(paymentType, count) {
    const pathPart = this.getPaymentTypePath(paymentType);
    const label = this.getPaymentTypeLabel(paymentType);
    return (
      <Link
        key={paymentType}
        className="school_money-home-new-payments__link"
        to={`/school_money/${pathPart}/`}
      >
        <Card className="school_money-home-new-payments__card">
          <BulletItem cssModifier="school_money">
            <div className="school_money-home-new-payments__item">
              <div className="school_money-home-new-payments__payment-type">{label}</div>
              <div className="school_money-home-new-payments__count">{count}</div>
            </div>
          </BulletItem>
        </Card>
      </Link>
    );
  }
  
  render() {
    
    const { isLoading, newCounts } = this.props;
    const items = newCounts.filter(([ paymentType, count ]) => count > 0);
    
    if (items.length === 0) {
      return null;
    }
      
    return (
      <div className="home-section school_money-home-new-payments">
        <div className="home-section-heading home-section-heading--school_money school_money-home-new-payments__heading">New Payments</div>
        <Preloader isLoading={isLoading}>
          <div className="school_money-home-new-payments__body">
            {
              items.map(([ paymentType, count ]) => (
                this.renderItem(paymentType, count)
              ))
            }
          </div>
        </Preloader>
      </div>
    );
    
  }
  
}

export default connect(
  state => ({
    isLoading: isActivePaymentsLoading(state),
    newCounts: [
      [ "payment",  getNewPaymentCount(state) ],
      [ "dinnerBooking",  getNewDinnerBookingCount(state) ],
      [ "clubBooking",  getNewClubBookingCount(state) ]
    ]
  })
)(NewPayments);



// WEBPACK FOOTER //
// ./src/components/app/home/sections/school_money/NewPayments.js